import React, { useEffect, useState } from "react";
import "./index.css";
import GraySearchIcon from "Assets/Icons/GraySearchIcon";

interface FilterItem {
  label: string;
  key: number;
  value: number;
}

interface FilterSearchListingProps {
  data: FilterItem[];
  selectedItem?: any;
  filterheadingListing: any;
  setfilterheadingListing: any;
  addDocumentTypeHandler?: any;
}

const FilterSearchListing: React.FC<FilterSearchListingProps> = ({
  data,
  selectedItem,
  filterheadingListing,
  setfilterheadingListing,
  addDocumentTypeHandler,
}) => {
  const [selectedFilters, setSelectedFilters] = useState<number[]>([]);
  const [searchInput, setSearchInput] = useState<string>("");
  const [inputText, setInputText] = useState<string>("");
  const arr: FilterItem[] = data;

  useEffect(() => {
    setSearchInput("");
  }, [selectedItem]);
  const handleCheckboxChange = (e: any, element: any) => {
    const { key } = element;

    // Find the item in filterheadingListing based on name
    const matchingItem = filterheadingListing.find(
      (ele: any) => ele.name === selectedItem.name
    );
    if (key == "all") {
      if (e.target.checked) {
        setSelectedFilters([
          "all",
          ...matchingItem.data.map((ele: any) => ele.key),
        ]);
        setfilterheadingListing((prev: any) =>
          prev.map((item: any) =>
            item.name === matchingItem.name
              ? {
                  ...item,
                  filterSelectedData: [...matchingItem.data, element],
                }
              : item
          )
        );
      } else {
        setSelectedFilters([]);
        setfilterheadingListing((prev: any) =>
          prev.map((item: any) =>
            item.name === matchingItem.name
              ? { ...item, filterSelectedData: [] }
              : item
          )
        );
      }
    }
    if (selectedItem.singleSelect) {
      // If singleSelect is true, handle single selection logic
      setSelectedFilters([key]);

      // Update filterSelectedData for the matching item
      if (matchingItem) {
        setfilterheadingListing((prev: any) =>
          prev.map((item: any) =>
            item.name === matchingItem.name
              ? { ...item, filterSelectedData: [element] }
              : item
          )
        );
      }
      if (selectedFilters.includes(key)) {
        // If the checkbox is already checked, uncheck it
        setSelectedFilters([]);
        // Clear filterSelectedData for the matching item
        if (matchingItem) {
          setfilterheadingListing((prev: any) =>
            prev.map((item: any) =>
              item.name === matchingItem.name
                ? { ...item, filterSelectedData: [] }
                : item
            )
          );
        }
      }
    } else {
      // If singleSelect is false, handle multiple selection logic
      if (selectedFilters.includes(key)) {
        setSelectedFilters((prev) => prev.filter((el) => el !== key));

        // Remove key from filterSelectedData for the matching item
        if (matchingItem) {
          setfilterheadingListing((prev: any) =>
            prev.map((item: any) =>
              item.name === matchingItem.name
                ? {
                    ...item,
                    filterSelectedData: item.filterSelectedData.filter(
                      (el: any) => el.key !== key && el.key != "all"
                    ),
                  }
                : item
            )
          );
        }
      } else {
        setSelectedFilters((prev) => [...prev, key]);

        // Add the entire element to filterSelectedData for the matching item
        if (matchingItem) {
          setfilterheadingListing((prev: any) =>
            prev.map((item: any) =>
              item.name === matchingItem.name
                ? {
                    ...item,
                    filterSelectedData: [...item.filterSelectedData, element],
                  }
                : item
            )
          );
        }
      }
    }
  };

  const handleSearchInputChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setSearchInput(event.target.value);
  };

  // Function to filter data based on the search input
  const filteredData = arr.filter((item) =>
    String(item.label).toLowerCase().includes(searchInput.toLowerCase())
  );
  const handleInputTextHandler = (e: any) => {
    const { value } = e.target;
    setInputText(value);
    const matchingItem = filterheadingListing.find(
      (ele: any) => ele.name === selectedItem.name
    );
    setfilterheadingListing((prev: any) =>
      prev.map((item: any) =>
        item.name === matchingItem.name
          ? { ...item, filterSelectedData: value }
          : item
      )
    );
  };
  return (
    <div className="w-100">
      {selectedItem.type ? (
        <div className="p-2">
          <input
            className="searchFilterInputTitle"
            type="text"
            placeholder={selectedItem.name}
            value={inputText}
            onChange={handleInputTextHandler}
          />
        </div>
      ) : (
        <div className="searchInputContainer">
          <GraySearchIcon className="searchIcon" />
          <input
            className="searchFilterInput"
            type="text"
            placeholder="Search..."
            value={searchInput}
            onChange={handleSearchInputChange}
          />
        </div>
      )}
      <div className="allChecboxDiv">
        {addDocumentTypeHandler && selectedItem.name === "Document Type" && (
          <div className="addNewDocDiv" onClick={addDocumentTypeHandler}>
            + Add New Document Type
          </div>
        )}
        {filteredData.map((item) => (
          <div key={item.key} className="checkboxDiv">
            <input
              className="form-check-input filterCheckbox"
              type="checkbox"
              onChange={(e) => handleCheckboxChange(e, item)}
              checked={selectedItem.filterSelectedData
                ?.map((ele: any) => ele.key)
                .includes(item.key)}
            />
            <span className="filterCheckboxSpan">{item.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterSearchListing;
